import styled from 'styled-components';

const InputWrap = styled.div`
    display: inline-block;
    width: 100%;
    margin-bottom: 1.438rem;
    position: relative;
`;

export default InputWrap;